<bb-transaction-signing-error *ngIf="error; else displayHoldingScreen" [error]="error"
  (close)="acceptError.emit($event)">
</bb-transaction-signing-error>

<ng-template #displayHoldingScreen>

  <bb-alert-ui *ngIf="pushFailure" data-role="ts-oob-device-incorrect-alert"
    i18n-title="Failure to send push notification for out of band device transaction signing@@bb-transaction-signing-oob-device.alert.failure.title"
    title="Push notification failure">
    <span i18n="Incorrect attempts alert message for sms otp signing@@bb-transaction-signing-oob-device.alert.failure.message">
      Failure to send push notification. Please open your app to complete the transaction.
    </span>
  </bb-alert-ui>

  <div class="bb-block bb-block--md">
    <div data-role="oob-device-title" class="bb-highlight bb-block bb-block--md"
      i18n="Instruction for oob device signing@@bb-transaction-signing-oob-device.instruction.check-device-header">
      Check your device:
    </div>
    <div class="bb-stack">
      <bb-icon-ui class="bb-stack__item" [name]="icon" size="xl" data-role="oob-device-icon"></bb-icon-ui>
      <div>
        <div *ngIf="deviceInfo?.friendlyName; else defaultFriendlyName" class="bb-stack__item bb-highlight">
          <span data-role="oob-device-friendly-name">{{ deviceInfo?.friendlyName }}</span>
        </div>
        <div *ngIf="deviceInfo?.vendor && deviceInfo?.model; else defaultVendor" class="bb-stack__item bb-text-support">
          <span data-role="oob-device-vendor-model">{{deviceInfo?.vendor}} {{deviceInfo?.model}}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="bb-block bb-block--md"
    i18n="Instruction for oob device signing@@bb-transaction-signing-oob-device.instruction">
    <strong>Please sign this transaction through your banking app. When confirmed, this page will refresh.</strong>
  </div>

  <div class="bb-block bb-block--lg">
    <ng-container *ngIf="enableResendPushNotification">

      <hr />

      <div class="bb-block bb-block--sm">
        <span data-role="oob-no-notification-title" class="bb-highlight"
          i18n="No notification received@@bb-oob-notification-signing.resend.no-notification">
          Didn't receive the notification?
        </span>
      </div>

      <ng-container *ngIf="pushData.resendAttemptsLeft > 0; else displayNoRemainingRequests">
        <ng-container *ngIf="(timeUntilResend$ | async) as time; else displayResendButton">
          <span class="bb-subtitle bb-text-support bb-block bb-block--sm"
            i18n="Time before resend@@bb-oob-notification-signing.resend.time-before">
            Next resend available in {{ time }} {time, plural, =1 {second} other {seconds}}
          </span>
        </ng-container>

        <ng-template #displayResendButton>
          <div class="bb-block bb-block--sm">
            <button bbButton buttonSize="md" data-role="oob-device-resend" color="link-text"
              i18n="Resend OOB notification button@@bb-oob-notification-signing.resend" (click)="this.resend.emit()">
              Send another notification
            </button>
          </div>

          <div class="bb-text-support">
            <span [ngClass]="{'bb-text-danger': pushData.resendAttemptsLeft===1}"
              i18n="Message resend alert message for oob signin@@bb-oob-signing.alert.resend.message">
              You have {{pushData.resendAttemptsLeft}} resend
              {pushData.resendAttemptsLeft, plural, =1 {attempt} other {attempts}} left.
            </span>
          </div>
        </ng-template>
      </ng-container>

      <ng-template #displayNoRemainingRequests>
        <span data-role="ts-oob-device-no-resend" class="bb-subtitle bb-text-danger"
          i18n="No device push notification resend attempts remaining@@bb-transaction-signing-oob-device.no-resend">
          You are out of resend attempts.
        </span>
      </ng-template>
    </ng-container>
  </div>

  <hr />

  <div class="bb-block bb-block--lg">
    <small i18n="Helper text for oob device signing@@bb-transaction-signing-oob-device.helper">
      Note: Navigation away from this modal will result in a cancellation of this transaction signing process.
    </small>
  </div>

  <div class="bb-button-bar">
    <button bbButton data-role="oob-device-cancel" class="bb-button-bar__button" color="secondary"
      (click)="cancel.emit()" i18n="Cancel button@@bb-transaction-signing-oob-device.cancel">
      Cancel transaction
    </button>
  </div>

  <ng-template #defaultFriendlyName
    i18n="Default friendly name@@bb-transaction-signing-oob-device.default-friendly-name">
    <span data-role="oob-device-friendly-name-default">Unknown Device</span>
  </ng-template>

  <ng-template #defaultVendor i18n="Device vendor default text@@bb-transaction-signing-oob-device.default-vendor">
    <span data-role="oob-device-vendor-default">Unknown</span>
  </ng-template>

</ng-template>
